// CodebarIn.jsx
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const CodebarIn = ({
  remaining,
  barcodeInput,
  onBarcodeInputChange,
  onBarcodeSubmit,
  barcodeError,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onBarcodeSubmit();
    }
  };

  return (
    <div
      className="p-field"
      style={{ border: '1px solid #ccc', padding: '1rem', marginTop: '1rem' }}
    >
      <h5>Insira o código de barras da palete (faltam {remaining})</h5>
      <InputText
        value={barcodeInput}
        onChange={onBarcodeInputChange}
        onKeyDown={handleKeyDown}
        placeholder="Digite o código e pressione Enter"
      />
      {barcodeError && <small className="p-error">{barcodeError}</small>}
      <div style={{ marginTop: '0.5rem' }}>
        <Button label="Adicionar" onClick={onBarcodeSubmit} />
      </div>
    </div>
  );
};

export default CodebarIn;
